(function () {
  var activeNavbar = null;

  function findNav(source) {
    if (!source) return document.querySelector('.nav');
    if (source.matches && source.matches('.nav')) return source;
    if (source.querySelector) return source.querySelector('.nav');
    return document.querySelector('.nav');
  }

  function createNavbar(nav) {
    var toggle = nav.querySelector('#rv-menu-toggle');
    var links = nav.querySelector('#rv-nav-links');
    var megaItem = nav.querySelector('.nav__item--mega');
    var megaTrigger = nav.querySelector('#rv-mega-trigger');
    var megaMenu = nav.querySelector('#rv-mega-menu');
    var megaBackdrop = nav.querySelector('#rv-mega-backdrop');
    var searchPanel = nav.querySelector('#rv-nav-search-panel');
    var searchInput = nav.querySelector('#Search-In-RV-Navbar');
    var searchClose = nav.querySelector('[data-rv-search-close]');
    var searchToggles = nav.querySelectorAll('[data-rv-search-toggle]');
    var bottomBar = document.getElementById('rv-bottom-bar');
    var bottomLinks = document.querySelectorAll('[data-rv-bottom-link]');
    var filterLinks = nav.querySelectorAll('.js-rv-filter-link');
    var closeMegaTimer;
    var closeSearchTimer;
    var compactScrollOffset = 32;
    var scrollTicking = false;
    var lastScrollY = window.scrollY || 0;

    function syncNavHeight() {
      var wasCompact = nav.classList.contains('is-compact');
      if (wasCompact) {
        nav.classList.remove('is-compact');
      }
      document.documentElement.style.setProperty('--rv-nav-height', nav.offsetHeight + 'px');
      if (wasCompact) {
        nav.classList.add('is-compact');
      }
    }

    function closeMega() {
      if (!megaItem || !megaTrigger) return;
      window.clearTimeout(closeMegaTimer);
      nav.classList.remove('is-mega-open');
      megaItem.classList.remove('is-open');
      megaTrigger.setAttribute('aria-expanded', 'false');
    }

    function openMega() {
      if (!megaItem || !megaTrigger) return;
      window.clearTimeout(closeMegaTimer);
      nav.classList.add('is-mega-open');
      megaItem.classList.add('is-open');
      megaTrigger.setAttribute('aria-expanded', 'true');
    }

    function scheduleMegaClose() {
      window.clearTimeout(closeMegaTimer);
      closeMegaTimer = window.setTimeout(closeMega, 120);
    }

    function setSearchExpanded(expanded) {
      searchToggles.forEach(function (toggleButton) {
        toggleButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    function setBottomBarHidden(hidden) {
      if (!bottomBar) return;
      bottomBar.classList.toggle('is-hidden', hidden);
    }

    function closeSearch() {
      if (!searchPanel) return;
      window.clearTimeout(closeSearchTimer);
      nav.classList.remove('is-search-open');
      document.body.classList.remove('overflow-hidden');
      setBottomBarHidden(false);
      setSearchExpanded(false);
      closeSearchTimer = window.setTimeout(function () {
        if (!nav.classList.contains('is-search-open')) {
          searchPanel.hidden = true;
        }
      }, 260);
    }

    function openSearch() {
      if (!searchPanel) return;
      window.clearTimeout(closeSearchTimer);
      closeMega();
      if (links) {
        links.classList.remove('is-open');
      }
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }
      searchPanel.hidden = false;
      document.body.classList.add('overflow-hidden');
      setBottomBarHidden(true);
      setSearchExpanded(true);

      window.requestAnimationFrame(function () {
        nav.classList.add('is-search-open');
        window.requestAnimationFrame(function () {
          if (searchInput) {
            searchInput.focus();
            searchInput.select();
          }
        });
      });
    }

    function toggleSearch() {
      if (!searchPanel) return;
      if (nav.classList.contains('is-search-open')) {
        closeSearch();
      } else {
        openSearch();
      }
    }

    function setCompactState() {
      nav.classList.toggle('is-compact', window.scrollY > compactScrollOffset);
    }

    function handleScroll() {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(function () {
        setCompactState();

        if (bottomBar && !bottomBar.classList.contains('is-hidden')) {
          var currentScrollY = window.scrollY;
          if (currentScrollY > 50) {
            bottomBar.classList.add('is-visible-scroll');
          } else {
            bottomBar.classList.remove('is-visible-scroll');
          }
        }

        scrollTicking = false;
      });
    }

    function setBottomBarActive(key) {
      if (!bottomLinks.length) return;
      bottomLinks.forEach(function (link) {
        link.classList.toggle('is-active', link.getAttribute('data-rv-bottom-link') === key);
      });
    }

    function syncBottomBarState() {
      if (!bottomLinks.length) return;

      var path = window.location.pathname.replace(/\/+$/, '') || '/';
      var hash = window.location.hash;

      if (path === '/cart') {
        setBottomBarActive('carrito');
        return;
      }

      if (
        path.indexOf('/collections') === 0 ||
        path.indexOf('/products') === 0 ||
        path.indexOf('/search') === 0
      ) {
        setBottomBarActive('catalogo');
        return;
      }

      if (path === '/pages/club') {
        setBottomBarActive('club');
        return;
      }

      if (path === '/' && hash === '#club') {
        setBottomBarActive('club');
        return;
      }

      if (path === '/') {
        setBottomBarActive('home');
        return;
      }

      bottomLinks.forEach(function (link) {
        link.classList.remove('is-active');
      });
    }

    function handleResize() {
      syncNavHeight();
      setCompactState();
      if (window.innerWidth <= 768) {
        closeMega();
      }
      closeSearch();
      setBottomBarHidden(false);
    }

    function handleEscape(event) {
      if (event.key === 'Escape') {
        closeMega();
        closeSearch();
      }
    }

    function handlePointerMove(event) {
      if (!megaItem || window.innerWidth <= 768 || !megaItem.classList.contains('is-open')) return;
      if (!megaItem.contains(event.target)) {
        scheduleMegaClose();
      }
    }

    function handleDocumentClick(event) {
      if (!nav.classList.contains('is-search-open') || !searchPanel) return;

      var clickedToggle = Array.prototype.some.call(searchToggles, function (toggleButton) {
        return toggleButton.contains(event.target);
      });

      if (clickedToggle || searchPanel.contains(event.target)) return;
      closeSearch();
    }

    syncNavHeight();
    setCompactState();
    syncBottomBarState();

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('hashchange', syncBottomBarState);
    window.addEventListener('resize', handleResize);

    if (megaTrigger && megaItem && megaMenu) {
      megaTrigger.addEventListener('mouseenter', function () {
        if (window.innerWidth > 768) openMega();
      });

      megaMenu.addEventListener('mouseenter', function () {
        if (window.innerWidth > 768) openMega();
      });

      megaItem.addEventListener('mouseleave', function () {
        if (window.innerWidth > 768) scheduleMegaClose();
      });

      megaTrigger.addEventListener('focus', openMega);
      megaMenu.addEventListener('focusin', openMega);

      megaItem.addEventListener('focusout', function (event) {
        if (!megaItem.contains(event.relatedTarget)) {
          scheduleMegaClose();
        }
      });

      megaTrigger.addEventListener('click', function () {
        if (window.innerWidth > 768) {
          openMega();
        }
      });

      document.addEventListener('keydown', handleEscape);
      document.addEventListener('pointermove', handlePointerMove);
    }

    if (megaBackdrop) {
      megaBackdrop.addEventListener('click', closeMega);
    }

    if (searchToggles.length && searchPanel) {
      searchToggles.forEach(function (toggleButton) {
        toggleButton.addEventListener('click', function (event) {
          event.preventDefault();
          toggleSearch();
        });
      });

      if (searchClose) {
        searchClose.addEventListener('click', closeSearch);
      }

      searchPanel.addEventListener('click', function (event) {
        if (event.target === searchPanel) {
          closeSearch();
        }
      });

      document.addEventListener('click', handleDocumentClick);
    }

    filterLinks.forEach(function (link) {
      link.addEventListener('click', closeMega);
    });

    if (toggle && links) {
      bottomLinks.forEach(function (link) {
        link.addEventListener('click', function () {
          links.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          setBottomBarHidden(false);
          var key = link.getAttribute('data-rv-bottom-link');
          if (key) {
            setBottomBarActive(key);
          }
        });
      });

      toggle.addEventListener('click', function () {
        closeMega();
        closeSearch();
        var isOpen = links.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        setBottomBarHidden(isOpen);
      });

      links.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          links.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          setBottomBarHidden(false);
        });
      });
    }

    return {
      nav: nav,
      sync: function () {
        syncNavHeight();
        setCompactState();
        syncBottomBarState();
        
        if (bottomBar && window.scrollY > 50) {
          bottomBar.classList.add('is-visible-scroll');
        }
      },
      destroy: function () {
        window.clearTimeout(closeMegaTimer);
        window.clearTimeout(closeSearchTimer);
        document.body.classList.remove('overflow-hidden');
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('hashchange', syncBottomBarState);
        window.removeEventListener('resize', handleResize);
        document.removeEventListener('keydown', handleEscape);
        document.removeEventListener('pointermove', handlePointerMove);
        document.removeEventListener('click', handleDocumentClick);
      },
    };
  }

  function initNavbar(source) {
    var nav = findNav(source);
    if (!nav) return;

    if (activeNavbar && activeNavbar.nav === nav) {
      activeNavbar.sync();
      return;
    }

    if (activeNavbar) {
      activeNavbar.destroy();
    }

    activeNavbar = createNavbar(nav);
  }

  initNavbar(document);

  document.addEventListener('shopify:section:load', function (event) {
    initNavbar(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!activeNavbar || !event.target || !event.target.contains(activeNavbar.nav)) return;
    activeNavbar.destroy();
    activeNavbar = null;
  });
})();

/* Barra superior en móvil: los cuatro apartados van pasando de uno en uno.
   En pantallas grandes caben todos a la vez, así que no rota. Si el visitante
   pide menos animación en su sistema, se queda quieto en el primero. */
(function () {
  var INTERVAL = 4000;
  var MOBILE = '(max-width: 768px)';
  var timer = null;
  var index = 0;

  function bar() {
    return document.querySelector('.rv-topbar');
  }

  function items(root) {
    return Array.prototype.filter.call(root.querySelectorAll('.rv-topbar__item'), function (el) {
      return el.textContent.trim() !== '';
    });
  }

  function show(list, i) {
    list.forEach(function (el, n) {
      el.classList.toggle('is-visible', n === i);
    });
  }

  function stop(root) {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
    if (!root) return;
    root.classList.remove('is-rotating');
    items(root).forEach(function (el) {
      el.classList.remove('is-visible');
    });
  }

  function start(root) {
    var list = items(root);
    if (list.length < 2) return;

    root.classList.add('is-rotating');
    if (index >= list.length) index = 0;
    show(list, index);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    timer = window.setInterval(function () {
      if (document.hidden) return;
      index = (index + 1) % list.length;
      show(list, index);
    }, INTERVAL);
  }

  function sync() {
    var root = bar();
    if (!root) return;
    stop(root);
    if (window.matchMedia(MOBILE).matches) start(root);
  }

  sync();
  window.addEventListener('resize', sync);
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('visibilitychange', function () {
    // Al volver a la pestaña, retoma en el apartado que tocaba.
    if (!document.hidden && timer) {
      var root = bar();
      if (root) show(items(root), index);
    }
  });
})();
